import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { InstanciasLogisticaContent } from './components/InstanciasLogisticaContent';

export default function DetalleGestionLogistica() {
    return (
        <MainContent
            component={<InstanciasLogisticaContent/>}
            titulo='Acciones Realizadas'
            noBackground
        />
    );

};
